<section class="linked" aria-label="Linked here">
  <h3 class="section-title">Linked here@if (totalRecords) { · {{ totalRecords }}}</h3>
  @for (group of groups; track group.date) {
    <div class="linked-day" data-testid="linked-day">
      <div class="linked-day-title mat-caption" data-testid="linked-day-title">{{ dayTitle(group.date) }} · {{ group.count }}</div>
      @for (row of group.rows; track row.uuid) {
        <div class="linked-row" role="button" tabindex="0" data-testid="linked-row" [class.linked-row--selected]="row.uuid === selectedUuid"
          [attr.aria-pressed]="row.uuid === selectedUuid" (click)="selectRecord.emit(row)" (keydown.enter)="selectRecord.emit(row)">
          <span class="linked-marker" data-testid="linked-row-marker" [class.linked-marker--open]="isOpen(row.status)">{{ row.marker_index }}</span>
          <span class="linked-row-text">
            <span class="linked-row-label">{{ row.label || noun(row.entity_type) }}</span>
            <span class="linked-row-meta mat-caption">{{ noun(row.entity_type) }}@if (row.created_by?.name) { · {{ row.created_by.name }}}</span>
          </span>
          <button type="button" class="link-button" data-testid="linked-row-open" (click)="open(row, $event)">Open</button>
        </div>
      }
    </div>
  } @empty {
    @if (!loading) {
      <p class="linked-empty mat-body-1">No records are linked to this sheet yet.</p>
    }
  }
  @if (totalRecords > pageSize) {
    <div class="linked-pager mat-caption">
      <button type="button" class="link-button" data-testid="linked-prev" [disabled]="!hasPrev" (click)="prev()">Previous</button>
      <span data-testid="linked-range">{{ rangeText }}</span>
      <button type="button" class="link-button" data-testid="linked-next" [disabled]="!hasNext" (click)="next()">Next</button>
    </div>
  }
</section>
